import React from "react";

import { toast } from "react-hot-toast";

import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import InputField from "../../components/inputField/inputField";
import TextEditor from "../../components/textEditor/textEditor";
import withRouter from "../../components/withRouter/withRouter";
import ToggleSwitch from "../../components/toggleSwitch";
import {
  addUpdateApi,
  deleteByIdApi,
  getAllApi,
  getByIdApi,
  getCategoriesApi,
  uploadImageApi,
} from "../../api";
import he from "he";
import CategoryDropDown from "../../components/categoryDropDown/CategoryDropDown";
import { isValidURL } from "../../utils/isValidUrl";

class AddUpdateSolutions extends React.Component {
  state = {
    imageUrl: "",
    imageObject: "",
    imageCaption: "",
    imageAlt: "",
    content: "",
    title: "",
    description: "",
    category: "",
    tags: [],
    tagText: "",
    adOneUrl: "",
    adTwoUrl: "",
    buttonOneUrl: "",
    buttonTwoUrl: "",
    loading: false,
    isImageChanged: false,
    author: "",
    showBtn: false,
    buttonText: "",
    buttonLink: "",
    keyPoints: [],
    keyPointsImage: { url: "", obj: "" },
    keyPointsImageCaption: "",
    keyPointsImageAlt: "",
    keyPointsHeading: "",
    qanda: [],
    why: [],
    whyHeading: "",
    fold1: [],
    fold1Heading: "",
    metaCanonicalUrl: "",
    metaTitle: "",
    metaDescription: "",
    slug: "",
    aboutSolution: {
      solutionName: "",
      solutionImage: { url: "", obj: "" },
      solutionImageCaption: "",
      solutionImageAlt: "",
    },
    categories: [],
    blogs: [],
    relatedBlogs: [],
    cta: {
      content: "",
      buttonText: "",
      buttonLink: "",
      showButton: false,
    },
  };

  componentDidMount() {
    this.getCategories();
    this.getBlogs();
    if (this.props.router.params.id) {
      this.setState({ loading: true });
      this.getData();
    }
  }

  getBlogs = () => {
    getAllApi("article")
      .then((response) => {
        this.setState({ blogs: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getCategories = () => {
    getCategoriesApi()
      .then((res) => {
        console.log(res);
        const d = res.data.filter((val) => val.categoryType === "Solution");

        this.setState({ categories: d });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getData = () => {
    getByIdApi("solution", this.props.router.params.id)
      .then((res) => {
        const temp = res.data;
        console.log("getting solution by id : ", temp?.aboutSolution);
        this.setState({
          imageUrl: temp?.bannerImage,
          imageCaption: temp?.bannerImageCaption,
          imageAlt: temp?.bannerImageAlt,
          showBtn: temp?.buttonShow,
          title: he.decode(temp?.title || ""),
          tags: temp?.tags,
          category: he.decode(temp?.category || ""),
          buttonText: temp?.buttonText,
          buttonLink: temp?.buttonLink,
          description: he.decode(temp?.description || ""),
          fold1: temp?.fold1?.details.map((v) => ({
            ...v,
            title: he.decode(v?.title || ""),
            description: he.decode(v?.description || ""),
          })),
          fold1Heading: he.decode(temp?.fold1?.heading || ""),
          keyPoints: temp?.keyPoints?.details.map((v) => ({
            ...v,
            title: he.decode(v?.title || ""),
            description: he.decode(v?.description || ""),
          })),
          keyPointsImage: { url: temp?.keyPoints?.image },
          keyPointsImageCaption: temp?.keyPoints?.imageCaption,
          keyPointsImageAlt: temp?.keyPoints?.imageAlt,
          keyPointsHeading: he.decode(temp?.keyPoints?.heading || ""),
          qandaHeading: he.decode(temp?.QAA?.heading || ""),
          qanda: temp?.QAA?.details.map((v) => ({
            ...v,
            question: he.decode(v?.question || ""),
            answer: he.decode(v?.answer || ""),
          })),
          why: temp?.whySection?.details.map((v) => ({
            ...v,
            icon: { url: v?.icon, obj: "" },
            title: he.decode(v?.title || ""),
            description: he.decode(v?.description || ""),
          })),
          aboutSolution: temp?.aboutSolution
            ? {
                ...temp?.aboutSolution,
                solutionImage: {
                  url: temp?.aboutSolution.solutionImage,
                  obj: "",
                },
              }
            : {
                solutionName: "",
                solutionImage: { url: "", obj: "" },
                solutionImageCaption: "",
                solutionImageAlt: "",
              },
          whyHeading: he.decode(temp?.whySection?.heading || ""),
          relatedBlogs: temp?.relatedArticles || [],
          cta: {
            content: he.decode(temp?.cta?.content || ""),
            showButton: temp?.cta?.showButton || false,
            buttonText: temp?.cta?.buttonText,
            buttonLink: temp?.cta?.buttonLink,
          },
          loading: false,
          metaCanonicalUrl: temp?.metaData?.canonicalUrl,
          metaTitle: temp?.metaData?.metaTitle,
          metaDescription: temp?.metaData?.metaDescription,
          slug: temp?.metaData?.slug,
        });
      })
      .catch((err) => {
        toast.error("Something went wrong while getting blog data.");
        this.props.router.navigate("/solutions");
      });
  };

  handleImage = (event) => {
    this.setState({
      imageUrl: URL.createObjectURL(event.target.files[0]),
      imageObject: event.target.files[0],
      isImageChanged: true,
    });
  };

  handleAboutSolutionImage = (event) => {
    this.setState({
      aboutSolution: {
        ...this.state.aboutSolution,
        solutionImage: {
          url: URL.createObjectURL(event.target.files[0]),
          obj: event.target.files[0],
        },
      },
    });
  };

  removeExtension(filename) {
    return filename.substring(0, filename.lastIndexOf(".")) || filename;
  }

  validate = () => {
    console.log(this.state.aboutSolution.solutionName);
    if (!this.state.aboutSolution.solutionName) {
      toast.error("Solution Name is required.");
      return false;
    }
    if (!this.state.imageUrl) {
      toast.error("Banner Image is required.");
      return false;
    }
    if (!this.state.imageCaption) {
      toast.error("Banner Image Caption is required.");
      return false;
    }
    if (!this.state.imageAlt) {
      toast.error("Banner Image Alt is required.");
      return false;
    }
    if (!this.state.title) {
      toast.error("Title is required.");
      return false;
    }
    if (!this.state.category) {
      toast.error("Category is required.");
      return false;
    }
    if (this.state.tags.length === 0) {
      toast.error("Keywords are required.");
      return false;
    }
    if (this.state.showBtn && !this.state.buttonText) {
      toast.error("Button Text is required.");
      return false;
    }
    if (this.state.showBtn && !this.state.buttonLink) {
      toast.error("Button Url is required.");
      return false;
    }
    if (this.state.showBtn && !isValidURL(this.state.buttonLink)) {
      toast.error("Please enter a valid button url.");
      return false;
    }
    if (!this.state.description) {
      toast.error("Description is required.");
      return false;
    }

    // Fold 1
    if (this.state.fold1.length === 0) {
      toast.error("Fold 1 is required.");
      return false;
    }

    if (!this.state.fold1Heading) {
      toast.error("Fold 1 Heading is required.");
      return false;
    }

    for (let i = 0; i < this.state.fold1.length; i++) {
      const vv = this.state.fold1[i];

      if (!vv.title) {
        toast.error("Fold 1 Title is required.");
        return false;
      }
      if (!vv.description) {
        toast.error("Fold 1 Description is required.");
        return false;
      }
    }

    // Key points
    if (this.state.keyPoints.length === 0) {
      toast.error("Key Points are required.");
      return false;
    }
    if (!this.state.keyPointsImage.url) {
      toast.error("Key Points Image is required.");
      return false;
    }
    if (!this.state.keyPointsImageCaption) {
      toast.error("Key Points Image Caption is required.");
      return false;
    }
    if (!this.state.keyPointsImageAlt) {
      toast.error("Key Points Image Alt is required.");
      return false;
    }
    for (let i = 0; i < this.state.keyPoints.length; i++) {
      const vv = this.state.keyPoints[i];

      if (!vv.title) {
        toast.error("Key Points list Title is required.");
        return false;
      }
      if (!vv.description) {
        toast.error("Key Points list Description is required.");
        return false;
      }
    }

    // Q and A
    if (this.state.qanda.length === 0) {
      toast.error("Q&A is required.");
      return false;
    }
    if (!this.state.qandaHeading) {
      toast.error("Q&A's heading is required.");
      return false;
    }
    for (let i = 0; i < this.state.qanda.length; i++) {
      const v = this.state.qanda[i];
      if (!v.question) {
        toast.error("Q&A's question is required.");
        return false;
      }
      if (!v.answer) {
        toast.error("Q&A's answer is required.");
        return false;
      }
    }

    // Why
    if (this.state.why.length === 0) {
      toast.error("Why section is required.");
      return false;
    }
    if (!this.state.whyHeading) {
      toast.error("Why Section's heading is required.");
      return false;
    }

    for (let i = 0; i < this.state.why.length; i++) {
      const v = this.state.why[i];
      if (!v.icon.url) {
        toast.error("Why Section's icon is required.");
        return false;
      }
      if (!v.iconCaption) {
        toast.error("Why Section's icon caption is required.");
        return false;
      }
      if (!v.iconAlt) {
        toast.error("Why Section's icon alt is required.");
        return false;
      }
      if (!v.title) {
        toast.error("Why Section's list title is required.");
        return false;
      }
      if (!v.description) {
        toast.error("Why Section's list description is required.");
        return false;
      }
    }

    if (!this.state.slug) {
      toast.error("Slug is required.");
      return false;
    }
    if (!this.state.metaTitle) {
      toast.error("Meta Title is required.");
      return false;
    }
    if (!this.state.metaDescription) {
      toast.error("Meta Description is required.");
      return false;
    }
    if (!this.state.metaCanonicalUrl) {
      toast.error("Canonical Url is required.");
      return false;
    }
    if (!isValidURL(this.state.metaCanonicalUrl)) {
      toast.error("Please enter valid canonical url.");
      return false;
    }
    return true;
  };

  uploadImage = async () => {
    if (this.state.imageObject) {
      try {
        const response = await uploadImageApi(
          this.state.imageObject,
          "solution"
        );

        return response.data.imageUrl;
      } catch (error) {
        console.log(error);
        throw error;
      }
    }

    return this.state.imageUrl;
  };

  getFold1Data = () => {
    const foldData = {
      heading: this.state.fold1Heading,
      details: this.state.fold1,
    };
    return foldData;
  };

  getKeyPointsData = async () => {
    const keyPointData = {
      heading: this.state.keyPointsHeading,
      details: this.state.keyPoints,
      imageCaption: this.state.keyPointsImageCaption,
      imageAlt: this.state.keyPointsImageAlt,
    };

    if (this.state.keyPointsImage.obj) {
      const r = await uploadImageApi(this.state.keyPointsImage.obj, "solution");
      keyPointData.image = r.data.imageUrl;
    } else {
      keyPointData.image = this.state.keyPointsImage.url;
    }

    return keyPointData;
  };

  getQAAData = () => {
    const qData = {
      heading: this.state.qandaHeading,
      details: this.state.qanda,
    };
    return qData;
  };

  getWhyData = async () => {
    console.log("inside why");
    const whyData = { heading: this.state.whyHeading, details: [] };

    for (let i = 0; i < this.state.why.length; i++) {
      if (this.state.why[i].icon.obj) {
        const ii = await uploadImageApi(this.state.why[i].icon.obj, "solution");

        whyData.details.push({
          icon: ii.data.imageUrl,
          title: this.state.why[i].title,
          description: this.state.why[i].description,
          iconCaption: this.state.why[i].iconCaption,
          iconAlt: this.state.why[i].iconAlt,
        });
      } else {
        whyData.details.push({
          icon: this.state.why[i].icon.url,
          title: this.state.why[i].title,
          description: this.state.why[i].description,
          iconCaption: this.state.why[i].iconCaption,
          iconAlt: this.state.why[i].iconAlt,
        });
      }
    }

    console.log("returning why data ::: ", whyData);

    return whyData;
  };

  getSolutionData = async () => {
    const aboutSolutionData = {};

    aboutSolutionData.solutionName = this.state.aboutSolution.solutionName;
    aboutSolutionData.solutionImageAlt = " ";
    aboutSolutionData.solutionImageCaption = " ";

    // if (this.state.aboutSolution.solutionImage.obj) {
    //   const img_url = await uploadImageApi(
    //     this.state.aboutSolution.solutionImage.obj,
    //     "solution"
    //   );
    //   aboutSolutionData.solutionImage = img_url.data.imageUrl;
    // } else {
    aboutSolutionData.solutionImage = " ";
    // }

    return aboutSolutionData;
  };

  handleSubmit = (event) => {
    if (event.target.name === "btn3") {
      this.props.router.navigate("/solutions");
    } else {
      if (this.validate()) {
        this.setState({ loading: true });

        console.log("inside submit");

        this.uploadImage()
          .then(async (res) => {
            let whyData = await this.getWhyData();

            let keyPointData = await this.getKeyPointsData();

            const s_d = await this.getSolutionData();
            console.log("solution data", s_d);
            let data = {
              bannerImage: res,
              bannerImageCaption: this.state.imageCaption,
              bannerImageAlt: this.state.imageAlt,
              title: this.state.title,
              category: this.state.category,
              tags: this.state.tags,
              buttonShow: this.state.showBtn,
              buttonText: this.state.buttonText,
              buttonLink: this.state.buttonLink,
              description: this.state.description,
              fold1: this.getFold1Data(),
              QAA: this.getQAAData(),
              whySection: whyData,
              keyPoints: keyPointData,
              aboutSolution: s_d,
              relatedArticles: this.state.relatedBlogs,
              cta: this.state.cta,
              metaData: {
                slug: this.state.slug,
                metaTitle: this.state.metaTitle,
                metaDescription: this.state.metaDescription,
                canonicalUrl: this.state.metaCanonicalUrl,
              },
            };

            console.log(data);

            const key = await this.getKeyPointsData();
            data.keyPoints = key;

            console.log(key);

            const why = await this.getWhyData();
            data.whySection = why;

            console.log("data to submit ::: ", data);

            addUpdateApi({
              data,
              type: "solution",
              method: this.props.router.params.id ? "patch" : "post",
              id: this.props.router.params.id,
            })
              .then((res) => {
                toast.success("Solution created successfully.");
                this.props.router.navigate("/solutions");
              })
              .catch((err) => {
                toast.error(err.response.data.message);

                this.setState({ loading: false });
              });
          })
          .catch((err) => {
            this.setState({ loading: false });
            toast.error(err.response.data.message);
          });
      }
    }
  };

  deleteCategory = (id) => {
    this.setState({ loading: true });
    deleteByIdApi("category", id)
      .then(() => {
        toast.success("Category deleted successfully.");
        getCategoriesApi()
          .then((res) => {
            const d = res.data.filter((val) => val.categoryType === "Solution");

            this.setState({ categories: d, loading: false });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        toast.error("Something went wrong while deleting category.");
      });
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title={this.props?.title ? "Update Solutions" : "Add New Solutions"}
            showBtn1={true}
            showBtn2={false}
            showBtn3={true}
            btn1type="filled"
            btn2type="outlined"
            btn3type="outlined_del"
            btn1Name="btn1"
            btn2Name="btn2"
            btn3Name="btn3"
            btn1Text={"Save"}
            btn2Text={"Save As Draft"}
            btn3Text={"Cancel"}
            onClickHandler={this.handleSubmit}
          />
          <ContentBody>
            <div className="grid">
              <div className="card grid">
                <h3>Solution Name</h3>
                <div>
                  <div className="grid" style={{ marginTop: "5px" }}>
                    <InputField
                      isLabel={false}
                      lable="Solution Name"
                      value={this.state.aboutSolution.solutionName}
                      onChange={(e) =>
                        this.setState({
                          aboutSolution: {
                            ...this.state.aboutSolution,
                            solutionName: e.target.value,
                          },
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="card grid">
                <h3>Hero</h3>
                <div>
                  <p
                    style={{
                      fontSize: ".9",
                      transform: "translateX(5px)",
                      marginTop: "10px",
                    }}
                  >
                    Banner Image
                    <span
                      style={{ color: "#a3a3a3", fontSize: ".8rem" }}
                    ></span>
                    {this.state.imageUrl && (
                      <span
                        style={{
                          display: "inline-flex",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          color: "#CB1829",
                          cursor: "pointer",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          this.setState({ imageUrl: "", imageObject: "" });
                        }}
                        title="Delete image"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    )}
                  </p>

                  {!this.state.imageUrl ? (
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        background: "transparent",
                        border: "1px dashed grey",
                        borderRadius: "10px",
                        margin: "10px",
                        cursor: "pointer",
                        position: "relative",
                        marginBottom: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      +
                      <input
                        type="file"
                        style={{
                          opacity: 0,
                          position: "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          left: 0,
                          cursor: "pointer",
                        }}
                        accept="image/*"
                        onChange={this.handleImage}
                      ></input>
                    </div>
                  ) : (
                    <div style={{ width: "45%", marginBottom: "40px" }}>
                      <div
                        style={{
                          width: "100%",
                          aspectRatio: "16/9",
                          backgroundImage: `url('${
                            this.props.router.params.id
                              ? this.state.isImageChanged
                                ? this.state.imageUrl
                                : this.state.imageUrl
                              : this.state.imageUrl
                          }')`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          marginTop: "10px",
                          borderRadius: "15px",
                          position: "relative",
                        }}
                      ></div>
                      {this.state.imageObject && (
                        <p style={{ textAlign: "center" }}>
                          {this.state.imageObject.name}
                        </p>
                      )}
                    </div>
                  )}
                  {this.state.imageUrl && (
                    <div className="grid_2">
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Caption"}
                        value={this.state.imageCaption}
                        onChange={(e) => {
                          this.setState({ imageCaption: e.target.value });
                        }}
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Alt"}
                        value={this.state.imageAlt}
                        onChange={(e) =>
                          this.setState({ imageAlt: e.target.value })
                        }
                      />
                    </div>
                  )}
                  <InputField
                    type="text"
                    value={this.state.title}
                    onChange={(e) => this.setState({ title: e.target.value })}
                    isLabel={true}
                    lable="Title"
                  />
                </div>

                <div className="grid_2">
                  <CategoryDropDown
                    categories={this.state.categories}
                    value={this.state.category}
                    placeholder="Select/Add Category"
                    onChange={(v) => this.setState({ category: v })}
                    deleteCategory={this.deleteCategory}
                  />
                  <div>
                    <InputField
                      type="text"
                      isLabel={true}
                      value={this.state.tagText}
                      lable={"Keywords (Press Enter to add value)"}
                      isRequired={false}
                      placeholder={"Comma separated values"}
                      onChange={(e) => {
                        this.setState({ tagText: e.target.value });
                      }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          this.setState({
                            tags: [...this.state.tags, this.state.tagText],
                            tagText: "",
                          });
                        }
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      {this.state.tags.map((tag, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              background: "var(--blue-light)",
                              color: "var(--blue-dark)",
                              padding: "5px 10px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            {tag}
                            <FontAwesomeIcon
                              icon={faClose}
                              style={{
                                color: "var(--blue-dark)",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                let temp = [...this.state.tags];
                                temp.splice(index, 1);
                                this.setState({ tags: temp });
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div
                    style={{
                      height: "50px",
                      width: "100%",
                      border: "1px solid lightgrey",
                      background: "white",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      paddingInline: "15px",
                      justifyContent: "space-between",
                      marginTop: "25px",
                    }}
                  >
                    <p>Show Button</p>
                    <ToggleSwitch
                      value={this.state.showBtn}
                      onClick={() =>
                        this.setState({ showBtn: !this.state.showBtn })
                      }
                    />
                  </div>
                  {this.state.showBtn && (
                    <>
                      <InputField
                        type="text"
                        isLabel={true}
                        value={this.state.buttonText}
                        lable="Button Text"
                        placeholder="Enter button text"
                        onChange={(e) =>
                          this.setState({ buttonText: e.target.value })
                        }
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        value={this.state.buttonLink}
                        lable="Button Link"
                        placeholder="Enter button Link"
                        onChange={(e) =>
                          this.setState({ buttonLink: e.target.value })
                        }
                      />
                    </>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <p style={{ paddingLeft: "5px" }}>Description</p>
                  <TextEditor
                    handleChange={(val) => {
                      this.setState({ description: val });
                    }}
                    content={this.state.description}
                  />
                </div>
              </div>

              <div className="card grid">
                <h3>
                  Fold 1
                  <button
                    onClick={() => {
                      let temp = [...this.state.fold1];
                      temp.push({
                        title: "",
                        description: "",
                      });
                      this.setState({ fold1: temp });
                    }}
                  >
                    Add
                  </button>
                </h3>
                {this.state.fold1.length !== 0 && (
                  <div className="grid">
                    <InputField
                      type="text"
                      value={this.state.fold1Heading}
                      onChange={(e) =>
                        this.setState({ fold1Heading: e.target.value })
                      }
                      isLabel={true}
                      lable="Heading"
                    />

                    {this.state.fold1.map((value, index) => {
                      return (
                        <div className="sub_card grid" key={index}>
                          <FontAwesomeIcon
                            icon={faClose}
                            className="sub_card_close"
                            onClick={() => {
                              let temp = this.state.fold1;
                              temp.splice(index, 1);
                              this.setState({ fold1: [...temp] });
                            }}
                          />
                          <InputField
                            type="text"
                            value={value.title}
                            onChange={(e) => {
                              let temp = [...this.state.fold1];
                              temp[index].title = e.target.value;
                              this.setState({ fold1: temp });
                            }}
                            isLabel={true}
                            lable="Title"
                          />

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Description</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.fold1];
                                temp[index].description = val;
                                this.setState({ fold1: temp });
                              }}
                              content={value.description}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="card grid">
                <h3>
                  Key Points
                  <button
                    onClick={() => {
                      let temp = [...this.state.keyPoints];
                      temp.push({
                        title: "",
                        description: "",
                      });
                      this.setState({ keyPoints: temp });
                    }}
                  >
                    Add
                  </button>
                </h3>
                {this.state.keyPoints.length !== 0 && (
                  <div className="grid">
                    <InputField
                      type="text"
                      value={this.state.keyPointsHeading}
                      onChange={(e) => {
                        this.setState({ keyPointsHeading: e.target.value });
                      }}
                      isLabel={true}
                      lable="Heading"
                    />

                    <div>
                      <p style={{ fontSize: ".9rem" }}>Key Points Logo</p>
                      {this.state.keyPointsImage.url ? (
                        <div style={{ width: "100px" }}>
                          <div
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "10px",
                              display: "flex",
                              border: "2px dashed var(--blue-dark)",
                              position: "relative",
                              marginTop: "10px",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faClose}
                              style={{
                                position: "absolute",
                                top: "0",
                                right: "0",
                                background: "var(--blue-light)",
                                color: "var(--blue-dark)",
                                borderRadius: "100%",
                                transform: "translate(50%,-50%)",
                                height: "15px",
                                width: "15px",
                                padding: "5px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                this.setState({
                                  keyPointsImage: { url: "", obj: "" },
                                });
                              }}
                            />
                            <img
                              src={this.state.keyPointsImage.url}
                              style={{
                                width: "100%",
                                height: "100px",
                                objectFit: "contain",
                                borderRadius: "10px",
                              }}
                              alt=""
                            />
                          </div>
                          {this.state.keyPointsImage?.obj && (
                            <p style={{ textAlign: "center" }}>
                              {this.state.keyPointsImage?.obj.name}
                            </p>
                          )}
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "2px dashed var(--blue-dark)",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              right: 0,
                              left: 0,
                              opacity: 0,
                            }}
                            onChange={(e) => {
                              this.setState({
                                keyPointsImage: {
                                  url: URL.createObjectURL(e.target.files[0]),
                                  obj: e.target.files[0],
                                },
                              });
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    {this.state.keyPointsImage?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Caption"}
                          value={this.state.keyPointsImageCaption}
                          onChange={(e) => {
                            this.setState({
                              keyPointsImageCaption: e.target.value,
                            });
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Alt"}
                          value={this.state.keyPointsImageAlt}
                          onChange={(e) =>
                            this.setState({ keyPointsImageAlt: e.target.value })
                          }
                        />
                      </div>
                    )}
                    {this.state.keyPoints.map((value, index) => {
                      return (
                        <div className="sub_card grid" key={index}>
                          <FontAwesomeIcon
                            icon={faClose}
                            className="sub_card_close"
                            onClick={() => {
                              let temp = this.state.keyPoints;
                              temp.splice(index, 1);
                              this.setState({ keyPoints: [...temp] });
                            }}
                          />
                          <InputField
                            type="text"
                            value={value.title}
                            onChange={(e) => {
                              let temp = [...this.state.keyPoints];
                              temp[index].title = e.target.value;
                              this.setState({ keyPoints: temp });
                            }}
                            isLabel={true}
                            lable="Title"
                          />

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Description</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.keyPoints];
                                temp[index].description = val;
                                this.setState({ keyPoints: temp });
                              }}
                              content={value.description}
                              smallEditor={true}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="card grid">
                <h3>
                  Q & A
                  <button
                    onClick={() => {
                      let temp = [...this.state.qanda];
                      temp.push({
                        question: "",
                        answer: "",
                      });
                      this.setState({ qanda: temp });
                    }}
                  >
                    Add
                  </button>
                </h3>
                {this.state.qanda?.length !== 0 && (
                  <div className="grid">
                    <InputField
                      type="text"
                      value={this.state.qandaHeading}
                      onChange={(e) => {
                        this.setState({ qandaHeading: e.target.value });
                      }}
                      isLabel={true}
                      lable="Heading"
                    />

                    {this.state.qanda.map((value, index) => {
                      return (
                        <div className="sub_card grid" key={index}>
                          <FontAwesomeIcon
                            icon={faClose}
                            className="sub_card_close"
                            onClick={() => {
                              let temp = this.state.qanda;
                              temp.splice(index, 1);
                              this.setState({ qanda: [...temp] });
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Question</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.qanda];
                                temp[index].question = val;
                                this.setState({ qanda: temp });
                              }}
                              content={value.question}
                              smallEditor={true}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Answer</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.qanda];
                                temp[index].answer = val;
                                this.setState({ qanda: temp });
                              }}
                              content={value.answer}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="card grid">
                <h3>
                  Why Section
                  <button
                    onClick={() => {
                      let temp = [...this.state.why];
                      temp.push({
                        title: "",
                        description: "",
                        icon: { url: "", obj: "" },
                        iconAlt: "",
                        iconCaption: "",
                      });
                      this.setState({ why: temp });
                    }}
                  >
                    Add
                  </button>
                </h3>
                {this.state.why.length !== 0 && (
                  <div className="grid">
                    <InputField
                      type="text"
                      value={this.state.whyHeading}
                      onChange={(e) => {
                        this.setState({ whyHeading: e.target.value });
                      }}
                      isLabel={true}
                      lable="Heading"
                    />

                    {this.state.why.map((value, index) => {
                      return (
                        <div className="sub_card grid" key={index}>
                          <FontAwesomeIcon
                            icon={faClose}
                            className="sub_card_close"
                            onClick={() => {
                              let temp = this.state.why;
                              temp.splice(index, 1);
                              this.setState({ why: [...temp] });
                            }}
                          />
                          <div>
                            <p style={{ fontSize: ".9rem" }}>Icon</p>
                            {value.icon.url ? (
                              <div
                                style={{
                                  width: "70px",
                                  height: "70px",

                                  background: "var(--blue-light)",
                                  borderRadius: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginTop: "5px",
                                  position: "relative",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faClose}
                                  style={{
                                    color: "var(--blue-dark)",
                                    cursor: "pointer",
                                    height: "15px",
                                    width: "15px",
                                    padding: "5px",
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                    transform: "translate(50%, -50%)",
                                  }}
                                  onClick={() => {
                                    let temp = [...this.state.why];
                                    temp[index].icon = { url: "", obj: "" };
                                    this.setState({ why: temp });
                                  }}
                                />
                                <img
                                  src={value.icon.url}
                                  alt=""
                                  style={{
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  width: "70px",
                                  height: "70px",
                                  position: "relative",
                                  background: "var(--blue-light)",
                                  borderRadius: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginTop: "5px",
                                }}
                              >
                                <input
                                  type="file"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    opacity: 0,
                                  }}
                                  accept="image/*"
                                  onChange={(e) => {
                                    let temp = [...this.state.why];
                                    temp[index].icon = {
                                      url: URL.createObjectURL(
                                        e.target.files[0]
                                      ),
                                      obj: e.target.files[0],
                                    };
                                    this.setState({ why: temp });
                                  }}
                                />
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  style={{ color: "var(--blue-dark)" }}
                                />
                              </div>
                            )}
                          </div>
                          {value.icon?.url && (
                            <div className="grid_2">
                              <InputField
                                type="text"
                                isLabel={true}
                                lable={"Image Caption"}
                                value={value.iconCaption}
                                onChange={(e) => {
                                  let temp = [...this.state.why];
                                  temp[index].iconCaption = e.target.value;
                                  this.setState({ why: temp });
                                }}
                              />
                              <InputField
                                type="text"
                                isLabel={true}
                                lable={"Image Alt"}
                                value={value.iconAlt}
                                onChange={(e) => {
                                  let temp = [...this.state.why];
                                  temp[index].iconAlt = e.target.value;
                                  this.setState({ why: temp });
                                }}
                              />
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Title</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.why];
                                temp[index].title = val;
                                this.setState({ why: temp });
                              }}
                              content={value.title}
                              smallEditor={true}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <p style={{ paddingLeft: "5px" }}>Description</p>
                            <TextEditor
                              handleChange={(val) => {
                                let temp = [...this.state.why];
                                temp[index].description = val;
                                this.setState({ why: temp });
                              }}
                              content={value.description}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Related Articles */}
              <div className="card grid">
                <h3>Related Articles</h3>
                <InputField
                  type="select"
                  options={this.state.blogs.filter((val) => {
                    const temp = this.state.relatedBlogs.filter(
                      (v) => v === val._id
                    );
                    return temp.length === 0 ? true : false;
                  })}
                  accessText="blogTitle"
                  accessValue="_id"
                  value=""
                  onChange={(e) => {
                    const temp_r = [...this.state.relatedBlogs, e.target.value];
                    this.setState({ relatedBlogs: temp_r });
                  }}
                />
                <div className="grid_3">
                  {this.state.relatedBlogs.map((value, index) => {
                    return (
                      <div key={index} className="sub_card">
                        <FontAwesomeIcon
                          icon={faClose}
                          className="sub_card_close"
                          onClick={() => {
                            let temp = [...this.state.relatedBlogs];
                            temp.splice(index, 1);
                            this.setState({ relatedBlogs: temp });
                          }}
                        />
                        <img
                          style={{
                            width: "100%",
                            aspectRatio: "1/1",
                            objectFit: "cover",
                          }}
                          src={
                            this.state.blogs.filter(
                              (val) => val._id === value
                            )[0]?.blogImage
                          }
                          alt=""
                        />
                        <p>
                          {
                            this.state.blogs.filter(
                              (val) => val._id === value
                            )[0]?.blogTitle
                          }
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="card grid">
                <h3>CTA</h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <p style={{ paddingLeft: "5px" }}>Content</p>
                  <TextEditor
                    handleChange={(val) => {
                      this.setState({
                        cta: { ...this.state.cta, content: val },
                      });
                    }}
                    content={this.state.cta.content}
                    smallEditor={true}
                  />
                </div>
                <div className="grid_2">
                  <div
                    style={{
                      height: "50px",
                      width: "100%",
                      border: "1px solid lightgrey",
                      background: "white",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      paddingInline: "15px",
                      justifyContent: "space-between",
                      marginTop: "25px",
                    }}
                  >
                    <p>Show Button</p>
                    <ToggleSwitch
                      value={this.state.cta.showButton}
                      onClick={() =>
                        this.setState({
                          cta: {
                            ...this.state.cta,
                            showButton: !this.state.cta.showButton,
                          },
                        })
                      }
                    />
                  </div>
                  {this.state.cta.showButton && (
                    <>
                      <InputField
                        type="text"
                        isLabel={true}
                        value={this.state.cta.buttonText}
                        lable="Button Text"
                        placeholder="Enter button text"
                        onChange={(e) =>
                          this.setState({
                            cta: {
                              ...this.state.cta,
                              buttonText: e.target.value,
                            },
                          })
                        }
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        value={this.state.cta.buttonLink}
                        lable="Button Link"
                        placeholder="Enter button Link"
                        onChange={(e) =>
                          this.setState({
                            cta: {
                              ...this.state.cta,
                              buttonLink: e.target.value,
                            },
                          })
                        }
                      />
                    </>
                  )}
                </div>
              </div>

              <div className="card grid">
                <h3>Meta Data</h3>
                <InputField
                  isLabel={true}
                  lable="Slug"
                  type="text"
                  value={this.state.slug}
                  onChange={(e) => this.setState({ slug: e.target.value })}
                />
                <InputField
                  isLabel={true}
                  lable="Meta Title"
                  type="text"
                  value={this.state.metaTitle}
                  onChange={(e) => this.setState({ metaTitle: e.target.value })}
                />
                <InputField
                  isLabel={true}
                  lable="Meta Description"
                  type="textarea"
                  value={this.state.metaDescription}
                  onChange={(e) =>
                    this.setState({ metaDescription: e.target.value })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Canonical Url"
                  type="textarea"
                  value={this.state.metaCanonicalUrl}
                  onChange={(e) =>
                    this.setState({ metaCanonicalUrl: e.target.value })
                  }
                />
              </div>
            </div>
          </ContentBody>
        </Content>
      </>
    );
  }
}

export default withRouter(AddUpdateSolutions);
